
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/our-team",
      function () {
        return require("private-next-pages/our-team.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/our-team"])
      });
    }
  